module.exports = __webpack_public_path__ + "img/Paginierung_Filled.3c8bca73.svg";